<template>
  <Breadcrumb>
    <BreadcrumbItem
      v-for="(item,index) in currentPath"
      :to="item.path"
      :key="index"
    >  <Icon :type="item.meta.icon"></Icon>{{ itemTitle(item) }}</BreadcrumbItem>
  </Breadcrumb>
</template>

<script>
export default {
  name: 'breadcrumbNav',
  props: {
    currentPath: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    itemTitle(item) {
      /* if (typeof item.title == 'object') {
        return this.$t(item.title.i18n)
      } else {
        return item.title
      } */
      return item.meta.name;
    }
  }
};
</script>
